<template>
    <div class="md:grid md:grid-cols-[3fr_7fr] md:gap-6">
        <jet-section-title>
            <template #title>
                <slot name="title"></slot>
            </template>
            <template #description>
                <slot name="description"></slot>
            </template>
        </jet-section-title>

        <div class="mt-5 rounded-lg border-iron-200 bg-white md:mt-0 border">
            <div class="bg-white p-6 shadow sm:rounded-lg">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import JetSectionTitle from "./SectionTitle.vue";

export default {
    components: {
        JetSectionTitle,
    },
};
</script>
